import defaultPartnerLogo from "../assets/images/client-logo.svg";

const getPartnerLogo = (logo) => (
  logo
    ? logo.replace("https://gleesim.com", "https://offers.gleesim.com")
    : defaultPartnerLogo
);

export default getPartnerLogo;
